import { useMemo, useState, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';

import type { ValueListKind } from '@config/interfaces';
import { ValueListTable } from './ValueListTable';

const KINDS: ValueListKind[] = ['fixed', 'entity'];

export const ValueListsTabs = (): ReactElement => {
  const { t } = useTranslation();
  const [activeKind, setActiveKind] = useState<ValueListKind>('fixed');

  const items = useMemo(
    () =>
      KINDS.map(kind => ({
        key: kind,
        label: t(`config.valueLists.tabs.${kind}`),
        children: <ValueListTable kind={kind} active={activeKind === kind} />,
      })),
    [activeKind, t],
  );

  return (
    <div className="enso-ui-tabs-wrapper">
      <Tabs items={items} activeKey={activeKind} onChange={key => setActiveKind(key as ValueListKind)} />
    </div>
  );
};
